
<app-form-input  [label]="'datePublication'"
        [name]="getUid()+'_SepAtt_datePublication'"
        [parentForm]="parentForm" [rule]="''" [type]="'date'"
        [value]="joce.datePublication">
</app-form-input>
